/* PANTHERATEC | Fera compact store reviews v3.7.
   Reads the LIVE Fera widget. Never stores review data or fakes a verified badge.
   Verification click is forwarded to Fera's own clickable trigger. */
(function () {
  'use strict';
  if (window.__ptcFeraCompactBound) return;
  window.__ptcFeraCompactBound = true;

  function fullText(root) {
    return ((root && (root.innerText || root.textContent)) || '').replace(/\s+/g, ' ').trim();
  }

  function scoreFromFera(widget, text) {
    var meta = widget.querySelector('[itemprop="ratingValue"], meta[itemprop="ratingValue"], [data-rating-value]');
    var raw = meta && (meta.getAttribute('content') || meta.getAttribute('data-rating-value') || meta.textContent);
    if (!raw) {
      var score = text.match(/(?:^|[^\d])([1-5][.,]\d{1,2})(?=[^\d]|$)/);
      raw = score && score[1];
    }
    // Some stores have a 5.0 average rendered as a plain "5".
    if (!raw) {
      var plain = text.match(/(?:Gesamt(?:durchschnitts)?bewertung|Overall rating|Rating)[^\d]{0,25}([1-5])(?:\s|$)/i);
      raw = plain && plain[1];
    }
    var val = Number(String(raw || '').trim().replace(',', '.'));
    return val >= 1 && val <= 5 ? val : null;
  }

  function countFromFera(widget, text) {
    var meta = widget.querySelector('[itemprop="reviewCount"], meta[itemprop="reviewCount"], [data-review-count]');
    var raw = meta && (meta.getAttribute('content') || meta.getAttribute('data-review-count') || meta.textContent);
    if (!raw) {
      var count = text.match(/([\d][\d.,\s]*)\s*(?:(?:Kunden|Customer|Store|Shop)\s*)?(?:Rezension\w*|Bewertung\w*|Reviews?|Ratings?)/i);
      raw = count && count[1];
    }
    var val = parseInt(String(raw || '').replace(/[^\d]/g, ''), 10);
    return Number.isSafeInteger(val) && val > 0 ? val : null;
  }

  function findFeraVerification(widget) {
    var selector = [
      '[aria-label*="verif" i]', '[aria-label*="prüf" i]',
      '[title*="verif" i]', '[title*="prüf" i]',
      '[class*="verification" i]', '[class*="verified" i]',
      '[class*="verify" i]', '[data-fera-verification]',
      '[data-testid*="verif" i]'
    ].join(', ');
    var nodes = widget.querySelectorAll(selector);
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      var clickable = el.closest('button, a, [role="button"]');
      if (clickable && widget.contains(clickable)) return clickable;
      if (el.matches('button, a, [role="button"]')) return el;
      // Fera sometimes makes a small clickable span/div.
      if (el.tagName === 'SPAN' || el.tagName === 'DIV' || el.tagName.toLowerCase() === 'svg') {
        // Native Fera verification icons are sometimes a clickable span or SVG
        // handled by delegated click listeners on an ancestor.
        return el;
      }
    }
    var candidate = widget.querySelector('[aria-haspopup="dialog"]');
    return candidate || null;
  }

  function initWidget(host) {
    if (host.dataset.ptcFeraInitialized === 'true') return;
    host.dataset.ptcFeraInitialized = 'true';
    var source = host.querySelector('[data-ptc-fera-source]');
    var widget = source && source.querySelector('[data-fera-widget]');
    var view = host.querySelector('[data-ptc-fera-view]');
    var scoreEl = host.querySelector('[data-ptc-fera-score]');
    var countEl = host.querySelector('[data-ptc-fera-count]');
    var starFill = host.querySelector('[data-ptc-fera-stars]');
    var verify = host.querySelector('[data-ptc-fera-verification]');
    if (!widget || !view || !scoreEl || !countEl || !starFill || !verify) return;
    var realVerify = null;

    function update() {
      var text = fullText(widget);
      var rating = scoreFromFera(widget, text);
      var count = countFromFera(widget, text);
      // Until Fera supplies actual rating and count, show nothing.
      if (!rating || !count) {
        view.hidden = true;
        host.dataset.ptcFeraState = 'loading';
        return;
      }
      scoreEl.textContent = rating.toLocaleString('de-DE', {maximumFractionDigits: 1});
      countEl.textContent = count.toLocaleString('de-DE') + (count === 1 ? ' Rezension' : ' Rezensionen');
      starFill.style.width = (rating / 5 * 100).toFixed(2) + '%';
      view.setAttribute('aria-label', rating.toLocaleString('de-DE', {maximumFractionDigits: 1}) + ' von 5 Sternen, ' + count + ' Rezensionen');
      realVerify = findFeraVerification(widget);
      verify.hidden = !realVerify;
      view.hidden = false;
      host.dataset.ptcFeraState = 'ready';
    }

    verify.addEventListener('click', function () {
      // The original native Fera trigger, not a separate mock popup.
      realVerify = findFeraVerification(widget);
      if (!realVerify) return;
      realVerify.dispatchEvent(new MouseEvent('click', {bubbles:true, cancelable:true, composed:true, view:window}));
    });
    var scheduled = false;
    var observer = new MutationObserver(function () {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(function () { scheduled = false; update(); });
    });
    observer.observe(widget, {childList:true, subtree:true, characterData:true});
    update();
  }

  function init(root) {
    (root || document).querySelectorAll('[data-ptc-fera-compact]').forEach(initWidget);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);
  document.addEventListener('shopify:section:load', function (e) { init(e.target || document); });
})();
